<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{ t('Sent reminder modal prefix - (Edit participant tab) - Send reminder to') }} {{recipient.firstname}} {{recipient.lastname || ''}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="send_reminder_form">
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <label>{{recipient.firstname}} {{recipient.lastname || ''}} ({{ t('Mobile no (general) - Mobile no') }})</label>
            <div>
                <div class="form-group">
                    <app-phone-input [formControl]="send_reminder_form.get('phone_no')" [isFormSubmitted]="formSubmitted"></app-phone-input>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button [disabled]="isSendReminder" type="button" class="btn btn-primary" rippleEffect (click)="sendReminder(action.SMS)">{{ t('Sent reminder modal button text - (Edit participant tab) - Send SMS') }} <span *ngIf="loaders['sms']" class="spinner-border spinner-border-sm ms-50"></span></button>
            <button [disabled]="isSendReminder" type="button" class="btn btn-primary" rippleEffect (click)="sendReminder(action.EMAIL)">{{ t('Sent reminder modal button text - (Edit participant tab) - Send Email') }} <span *ngIf="loaders['email']" class="spinner-border spinner-border-sm ms-50"></span></button>
            <button [disabled]="isSendReminder" type="button" class="btn btn-primary" rippleEffect (click)="sendReminder(action.BOTH)">{{ t('Sent reminder modal button text - (Edit participant tab) - Both') }} <span *ngIf="loaders['both']" class="spinner-border spinner-border-sm ms-50"></span></button>
        </div>
    </form>
</ng-container>